import type {
  CommonResponseTeacherSettingDto,
  TeacherLabSettingDto,
  TeacherSettingDto,
  TeacherWorkbookSearchSettingDto,
  TeacherWorksheetSearchSettingDto,
  UpdateTeacherSettingData,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'
import type { WithNullableOptionals } from '~/http/request'

import { adaptTeacherSetting } from './adapters'
import type { TeacherSetting } from './schemas'

/** 로그인한 선생님의 설정 */
export const getTeacherSetting = async (meta?: RequestMeta): Promise<TeacherSetting> => {
  const body = await httpClient().get<CommonResponseTeacherSettingDto>('/teachers/setting', {
    meta,
  })
  return adaptTeacherSetting(body.data)
}

// 저장은 설정 전체를 바꾼다. 검색·빠른 메뉴·연구소 설정과 그 안의 값은 서버가 nullable 로 받는다.
// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 teacher/model/dto/TeacherSettingDto.kt 로 확인.
export type TeacherSettingBody = Omit<
  WithNullableOptionals<TeacherSettingDto>,
  'worksheetSearchSetting' | 'workbookSearchSetting' | 'labSetting'
> & {
  worksheetSearchSetting?: WithNullableOptionals<TeacherWorksheetSearchSettingDto> | null
  workbookSearchSetting?: WithNullableOptionals<TeacherWorkbookSearchSettingDto> | null
  labSetting?: WithNullableOptionals<TeacherLabSettingDto> | null
}

export const updateTeacherSetting = async (
  body: TeacherSettingBody,
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().post<UpdateTeacherSettingData>('/teachers/setting', body, { meta })
}
